import React, {
  ReactNode,
  FunctionComponent,
  useEffect,
  //useContext,
  useState
} from 'react';
import { useStepper } from '../../../../hooks';
import { Accordion, Box } from '@chakra-ui/react';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile } from '../../../../utils';
import { StepperPrevious } from './stepper-previous';
//import { FormContext } from '../../../../context';
interface StepperProps {
  previousButtonTexts: string[];
  children: ReactNode;
  activeStep?: number;
  allowMultiple?: boolean;
}

export const Stepper: FunctionComponent<StepperProps> = ({
  children,
  previousButtonTexts,
  activeStep,
  allowMultiple = true
}) => {
  const { setSteps, steps, currentStep, setCurrentStep, setStepActive } = useStepper();
  //const formContext = useContext(FormContext);
  const isMobile = useMediaQuery(mainMediaMobile);
  const [expandedIndices, setExpandedIndices] = useState<number[]>([]);
  const hasCurrentStep = currentStep && currentStep !== 0 && currentStep !== steps.length;

  function handleBackClick() {
    if (currentStep && currentStep !== 0) {
      const id = currentStep - 1;
      setStepActive(currentStep, false);
      setCurrentStep(id);
      //formContext.updateData(null);
    }
  }

  useEffect(() => {
    const stepperSteps = React.Children.toArray(children)
      .map((step) => {
        if (React.isValidElement(step)) {
          return {
            ...step.props,
            isValid: false,
            isActive: activeStep ? activeStep === step.props.id : currentStep === step.props.id,
            isTouched: activeStep ? activeStep === step.props.id : currentStep === step.props.id
          };
        }
        return null;
      })
      .filter(Boolean);
    setSteps(stepperSteps);
  }, []);

  useEffect(() => {
    const activeIndices = steps
      .map((step, index) => (step.isActive ? index : null))
      .filter((index): index is number => index !== null);
    setExpandedIndices(activeIndices);
  }, [steps, setExpandedIndices]);

  return (
    <Box className="flex w-full">
      {!isMobile && (
        <Box className={`md:mt-20 md:w-20 md:ml-5`}>
          {steps.length > 0 &&
            steps.map((step, key) => (
              <span
                key={key}
                className={`w-4 h-4 mt-2 rounded-full border-blue-500 border-2 border-solid flex items-center justify-center text-white ${
                  step.isTouched ? 'bg-blue-500' : ''
                }`}></span>
            ))}
        </Box>
      )}
      <Box className="w-full">
        {hasCurrentStep && isMobile ? (
          <StepperPrevious
            currentStep={currentStep}
            totalSteps={steps.length}
            title={previousButtonTexts[currentStep - 1]}
            handleBackClick={handleBackClick}
          />
        ) : null}
        <Accordion index={expandedIndices} allowMultiple={allowMultiple}>
          {steps.length > 0 && children}
        </Accordion>
      </Box>
    </Box>
  );
};
